'use client';

import { c as _c } from "react/compiler-runtime";
import { uniqueId } from 'lodash';
import React from 'react';
import { cn } from '@src/utils/tailwind';
import { IconText } from '../IconText/IconText';
export const Columns = ['1', '2', '3', '4', '5'] as const;
interface OfferCheckProps {
  items?: Array<{
    value?: string;
  }>;
  checkColor?: string;
  columns?: (typeof Columns)[number];
}
export const OfferSubtitleChecks = props => {
  const $ = _c(14);
  const {
    items: t0,
    checkColor: t1,
    columns: t2
  } = props;
  let t3;
  if ($[0] !== t0) {
    t3 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const items = t3;
  const checkColor = t1 === undefined ? "var(--color-bodi-accent-bright-700)" : t1;
  const columns = t2 === undefined ? "2" : t2;
  const t4 = columns === "1";
  const t5 = columns === "2";
  const t6 = columns === "3";
  const t7 = columns === "4";
  const t8 = columns === "5";
  let t9;
  if ($[2] !== t4 || $[3] !== t5 || $[4] !== t6 || $[5] !== t7 || $[6] !== t8) {
    t9 = cn("mx-auto grid grid-cols-1 gap-2", {
      "lg:grid-cols-1": t4,
      "lg:grid-cols-2": t5,
      "lg:grid-cols-3": t6,
      "lg:grid-cols-4": t7,
      "lg:grid-cols-5": t8
    });
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== checkColor || $[9] !== items) {
    t10 = items?.map(t11 => {
      const {
        value
      } = t11;
      return <IconText iconColor={checkColor} iconName="CheckCircleIcon" key={uniqueId()}><div className="text-left text-body-md" dangerouslySetInnerHTML={{
          __html: value ?? ""
        }} /></IconText>;
    });
    $[8] = checkColor;
    $[9] = items;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t9) {
    t11 = <div className={t9}>{t10}</div>;
    $[11] = t10;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
};